/**
 * Demo mode of the checked-in event, like the native app: the server flag force_testmode, or
 * an event in creation or test mode played outside its event window. The "Demo Mode" stamp
 * appears DEMO_STAMP_DELAY_MS after the condition first held, at once for forced events.
 * Pure module; the timezone parser is injected as parseInTz(naiveDateTime, timezone) -> ms.
 */
import { isEventActive, isTestModeEvent } from './event-list.mjs';

export const DEMO_STAMP_DELAY_MS = 5 * 60 * 1000;

/** The server forces the demo display: event of a test account, or the team is an operator device. */
export function isForcedDemoMode(event) {
    return !!event && toBool(event.force_testmode);
}

/** Forced, or creation/test mode while the event is not running (start not reached or play time over). */
export function isDemoModeEvent(event, nowMs, parseInTz) {
    if (!event) {
        return false;
    }
    return isForcedDemoMode(event) || (isTestModeEvent(event) && !isEventActive(event, nowMs, parseInTz));
}

/**
 * Stamp visibility: alwaysShow and forced events show it at once, otherwise the demo condition
 * must hold now and must have held since sinceMs for at least DEMO_STAMP_DELAY_MS.
 */
export function shouldShowDemoStamp(event, sinceMs, nowMs, parseInTz, alwaysShow = false) {
    if (!event) {
        return false;
    }
    if (alwaysShow || isForcedDemoMode(event)) {
        return true;
    }
    if (!isDemoModeEvent(event, nowMs, parseInTz)) {
        return false;
    }
    return sinceMs !== null && isFinite(sinceMs) && nowMs - sinceMs >= DEMO_STAMP_DELAY_MS;
}

function toBool(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
}
